module.exports = __webpack_public_path__ + "media/dev-connector.2def0021.mp4";